export default __webpack_public_path__ + "static/guarantee-543fe428818520b7f80f73e81489cb92.svg";